import { Alert, Button, Grid } from "@mui/material";
import { useState } from "react";

import Loading from "../../../../components/loading/Loading";

const AuthRehabButtons = ({
  rehabilitationApproved,
  changeRehabilitationApproved
}) => {
  const [success, setSuccess] = useState({ severity: "", text: "" });
  const [isLoading, setIsLoading] = useState(false);
  const changeRehabStatus = async (status) => {
    try {
      setIsLoading(true);
      await changeRehabilitationApproved(status);

      setIsLoading(false);
      setSuccess({ severity: "success", text: "Actualizado" });
      setTimeout(() => {
        setSuccess({ severity: "", text: "" });
      }, 3000);
    } catch (error) {
      setIsLoading(false);
      setSuccess({ severity: "error", text: String(error) });
      console.log(error);
      setTimeout(() => {
        setSuccess({ severity: "", text: "" });
      }, 3000);
    }
  };

  return (
    <>
      <Grid container columnSpacing={5}>
        <Grid item xs={12} md={6}>
          <Button
            variant="contained"
            fullWidth
            disabled={rehabilitationApproved || isLoading}
            onClick={() => changeRehabStatus(true)}
          >
            Autorizar rehabilitación
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Button
            variant="blue"
            fullWidth
            disabled={!rehabilitationApproved || isLoading}
            onClick={() => changeRehabStatus(false)}
          >
            Rechazar rehabilitación
          </Button>
        </Grid>
      </Grid>
      {isLoading && <Loading />}
      {success.severity !== "" && (
        <Alert severity={success.severity}>{success.text}</Alert>
      )}
    </>
  );
};

export default AuthRehabButtons;
